<template>
  <div class="standalone-logo-tile" :style="{ width: size + 'px', height: size + 'px' }">
    <img v-if="resolvedSrc && !failed" :src="resolvedSrc" :alt="alt" referrerpolicy="no-referrer" @error="failed = true" />
    <span v-else class="standalone-logo-fallback" :style="{ fontSize: Math.round(size * 0.42) + 'px' }">
      {{ initial }}
    </span>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import type { TenantBranding } from "@tenant-theme";

/**
 * White rounded-square brand tile — see frontend-style-guide.md "Logos vs
 * avatars". THIS tile is always drawn white, so a mark placed inside it must
 * always be the dark-ink `logoLightUrl` variant, regardless of the active
 * theme — `logoDarkUrl` exists only for a mark drawn RAW on dark chrome,
 * which this shell never does (bug: the default WHITE MetaShip cube landed
 * on this white tile in dark mode because callers picked `logoDarkUrl` off
 * the current theme). Pass `branding` for the tenant's OWN mark (Login,
 * TopBar, Sidebar, AppHome hero, NoAccess, Unavailable, OrgPicker chrome
 * logo) so this rule can't regress at a call site; pass `src` directly only
 * for an image with no light/dark pair (an organisation's own logo/icon).
 */
export default defineComponent({
  name: "LogoTile",
  props: {
    branding: { type: Object as () => TenantBranding | null, default: null },
    src: { type: String as () => string | null, default: null },
    alt: { type: String, default: "" },
    size: { type: Number, default: 32 },
  },
  setup(props) {
    const failed = ref(false);
    const resolvedSrc = computed(() => (props.branding ? props.branding.logoLightUrl : props.src) || null);
    watch(resolvedSrc, () => {
      failed.value = false;
    });
    const initial = computed(() => props.alt?.trim()?.[0]?.toUpperCase() || "?");
    return { resolvedSrc, failed, initial };
  },
});
</script>
